import React from 'react';
import cn from 'classnames';

import { Drawer as AntDrawer } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';
import { XmarkIcon } from '@revfluence/fresh-icons/solid';

import styles from './Drawer.module.scss';

export interface IDrawerProps extends DrawerProps {
  size?: 'default' | 'large';
}

/**
 * Drawer component
 */
export const Drawer: React.FC<IDrawerProps> = ({ className, ...props }) => {
  const { closeIcon = <XmarkIcon />, size = 'default' } = props;

  return (
    <AntDrawer
      closeIcon={closeIcon}
      size={size}
      className={cn(styles.Drawer, className)}
      {...props}
    />
  );
};
